module.exports = __webpack_public_path__ + "static/img/white_lock.6d0da1c6.svg";